import { motion } from "framer-motion";
import { Home, Archive, Building2, ScrollText, ArrowRight } from "lucide-react";
import { BOXES_IMAGE, CELLAR_IMAGE } from "@/constants/site";

const services = [
  {
    icon: Home,
    title: "Case e appartamenti",
    text: "Svuotiamo intere abitazioni: mobili, elettrodomestici, suppellettili. Ideale prima di una vendita, un affitto o un trasloco.",
    image: BOXES_IMAGE,
    tall: true,
    testid: "service-case",
  },
  {
    icon: Archive,
    title: "Cantine, solai e garage",
    text: "Liberiamo cantine, soffitte e box da anni di accumuli. Portiamo via tutto e lasciamo il locale pulito e agibile.",
    image: CELLAR_IMAGE,
    tall: true,
    testid: "service-cantine",
  },
  {
    icon: ScrollText,
    title: "Eredità e lutti",
    text: "Sgombero di appartamenti dopo un lutto, con cura, discrezione e rispetto per i beni e per i ricordi della famiglia.",
    testid: "service-eredita",
  },
  {
    icon: Building2,
    title: "Uffici e aziende",
    text: "Sgombero di uffici, negozi e magazzini per cambi sede o chiusure. Lavoriamo anche con agenzie immobiliari e amministratori di condominio.",
    testid: "service-uffici",
  },
];

export default function Services() {
  return (
    <section id="servizi" data-testid="services-section" className="border-t border-slate-200 bg-white py-24">
      <div className="mx-auto max-w-7xl px-6">
        <div className="max-w-2xl">
          <p className="text-sm font-bold uppercase tracking-widest text-orange-500">Cosa sgomberiamo</p>
          <h2 className="mt-3 text-3xl font-semibold tracking-tight text-slate-900 sm:text-4xl lg:text-5xl">
            Ogni spazio torna libero
          </h2>
          <p className="mt-4 text-base text-slate-600 md:text-lg">
            Dal singolo locale all'intero edificio: pensiamo a carico, trasporto, smaltimento e pulizia finale.
          </p>
        </div>

        <div className="mt-14 grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-4">
          {services.map((s, i) => (
            <motion.article
              key={s.title}
              data-testid={s.testid}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
              className={`group flex flex-col overflow-hidden rounded-lg border border-slate-200 bg-slate-50 transition-all duration-300 hover:-translate-y-1 hover:border-orange-400 ${
                s.tall ? "lg:row-span-1" : ""
              }`}
            >
              {s.image && (
                <div className="h-44 overflow-hidden">
                  <img
                    src={s.image}
                    alt={s.title}
                    className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
              )}
              <div className="flex flex-1 flex-col p-7">
                <s.icon className="h-8 w-8 text-orange-500" />
                <h3 className="mt-4 font-display text-xl font-semibold text-slate-900">{s.title}</h3>
                <p className="mt-3 flex-1 text-sm leading-relaxed text-slate-600">{s.text}</p>
                <a
                  href="#preventivo"
                  data-testid={`${s.testid}-cta`}
                  className="mt-5 inline-flex items-center gap-1.5 text-sm font-semibold text-orange-600 transition-colors duration-200 hover:text-orange-700"
                >
                  Chiedi un preventivo <ArrowRight className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-1" />
                </a>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
